export function getFieldDisabledProps({ isSubmitting }) {
  return isSubmitting ? { disabled: true } : null
}
